<template>
  <div>

    <a-form layout="vertical">
      <a-form-item label="执行任务分类">
        <a-select :size="$globalSize" @change="handleChange" v-model="currentNode.job_type">

          <a-select-option v-for="item in selectList.options" :key="item.value" :value="item.value">
            {{ item.title }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="选择执行任务">
        <a-table :row-selection="{ selectedRowKeys: jobList.selectedRowKeys, onChange: onSelectChange, type: 'radio' }"
                 :columns="jobList.columns" :data-source="jobList.tableData" :pagination="false" row-key="id">
        </a-table>

      </a-form-item>

      <a-form-item :label="nodeName">

        <a-input :size="$globalSize" :value="thread" style="width: 100%" placeholder="选择执行关联任务"/>
      </a-form-item>
    </a-form>
    <div :style="{
      position: 'absolute',
      right: 0,
      bottom: 0,
      width: '100%',
      borderTop: '1px solid #e9e9e9',
      padding: '10px 16px',
      background: '#fff',
      textAlign: 'right',
      zIndex: 1,
    }">
      <a-button  :size="$globalSize"  type="primary" @click="onHandleOk">
        确认绑定
      </a-button>

    </div>


    <!--    <component :is="(selectNode.type||'').toLowerCase()" v-else :config="selectNode.props"/>-->
  </div>
</template>

<script>
import Approval from './ApprovalNodeConfig.vue'
import Condition from './ConditionNodeConfig.vue'
import Delay from './DelayNodeConfig.vue'
import Cc from './CcNodeConfig.vue'
import Trigger from './TriggerNodeConfig.vue'
import FormAuthorityConfig from './FormAuthorityConfig.vue'
import Root from './RootNodeConfig.vue'
import workflow from "@/interface/pages/workflow/workflow";

const job_columns = [
  {
    title: '任务ID',
    dataIndex: 'id',
    key: 'id',
    align: 'center'
  },
  {
    title: '任务名称',
    dataIndex: 'job_name',
    key: 'job_name',
    align: 'center'
  },
  {
    title: '执行线程',
    dataIndex: 'thread',
    key: 'thread',
    ellipsis: true,
    align: 'center'
  }

]
export default {
  name: "NodeConfig",
  components: {
    Approval,
    Condition,
    Trigger,
    Delay,
    Root,
    Cc,
    FormAuthorityConfig
  },
  data() {
    return {
      currentNode: {},
      nodeName: '',
      thread: '',
      selectList: {
        options: [
          {title: "创建", value: 'create'},
          {title: "过滤", value: 'filter'},
          {title: "生成", value: 'build'},
          {title: "回传", value: 'upload'},
          {title: "检查", value: 'check'},
          {title: "推送", value: 'push'},
          {title: "合并", value: 'merge'},
          {title: '平台', value:'service'}
        ],
        value: ''

      },

      jobList: {
        selectedRowKeys: [],
        selectedRow: [],
        spinning: false,
        totalCount: 0,
        curPage: 1,
        pageSize: 10,
        tableData: [],
        columns: job_columns
      }

    }
  },
  computed: {
    selectNode() {
      return this.$store.state.selectedNode
    },
    formConfig() {
      return this.$store.state.design.formItems
    },
    name() {
      switch (this.selectNode.type) {
        case 'ROOT':
          return '设置发起人';
        case 'APPROVAL':
          return '设置审批人';
        case 'CC':
          return '设置抄送人';
        default:
          return null;
      }
    }
  },
  mounted() {

    this.initNodeName();
  },
  emits: ["onClose"],
  methods: {
    handleChange(selectedItems) {
      this.selectedItems = selectedItems;
      this.getJobListByType(selectedItems);
    },
    initNodeName() {
      this.nodeName = "【" + this.$store.state.selectedNode.name + "】节点关联的任务";
    },

    async getJobListByType(type) {
      this.jobList.spinning = true

      var params = {
        type: type,

      };

      workflow.getJobListByType(this, {params: params}).then(
          function (resp) {
            let res = resp.data;

            if (res.code == '200') {

              setTimeout(() => {
                this.jobList.tableData = res.data;
                this.jobList.totalCount = res.totalCount;
                this.jobList.spinning = false
              }, 700)
            } else {
              this.jobList.spinning = false
            }
          }.bind(this)
      ).catch(reason => {
        console.log(reason);
      })
    },
    onSelectChange(selectedRowKeys, row) {
      this.jobList.selectedRowKeys = selectedRowKeys;
      this.jobList.selectedRow = row[0];
      this.thread = row[0].thread;
    },
    onHandleOk() {
      //this.$store.state.selectedNode.desc=this.jobList.sample_thread
      this.$store.state.selectedNode.name = this.jobList.selectedRow.job_name
      this.$store.state.selectedNode.job_type = this.jobList.selectedRow.job_type
      this.$store.state.selectedNode.job_id = this.jobList.selectedRow.id
      this.$store.state.selectedNode.thread = this.jobList.selectedRow.sample_thread
      this.$store.state.selectedNode.thread_all = this.jobList.selectedRow.thread
      this.$emit("onClose");
    }
  },
  watch: {
    '$store.state.selectedNode': {
      handler(v) {
        v.job_id && (this.jobList.selectedRowKeys = [v.job_id])
        v.thread && (this.jobList.selectedRow.sample_thread = v.thread)
        v.thread_all && (this.thread = v.thread_all)
        v.job_type && (this.getJobListByType(v.job_type))
        this.currentNode = v
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped></style>
